import Checkbox from '@mui/material/Checkbox';

const SelectBox = (props) => {
  const { id, isDisabled, value } = props;

  return <Checkbox disabled={isDisabled} id={`checkbox-${id}`} checked={value} className="task-row-checkbox" />;
};

export default SelectBox;
